export default "__VITE_ASSET__e5979373__"